import React, { useState } from "react";
import styles from "./ShowBoosters.module.css";
import Booster from "../Booster";
import {
  archiveBoosters,
  boosterData,
  deleteBoosters,
} from "../../../services/BoosterServices";
import { useAlert } from "../../../context/AlertProvider";
import { FaTimes } from "react-icons/fa";
import globalStyles from "../../../styles/globalStyles.module.css";
import cardStyles from "../../Cards/ShowCards/ShowCards.module.css";
import { useTranslation } from "react-i18next";

export type ShowBoostersProps = {
  showInStore?: boolean;
  boosters: boosterData[];
  disableDelete?: boolean;
  handleAddOrRemoveBoosters?: (boosters: boosterData[]) => void;
  showInArchive?: boolean;
};
const ShowBoosters: React.FC<ShowBoostersProps> = ({
  boosters,
  showInStore,
  disableDelete = true,
  handleAddOrRemoveBoosters,
  showInArchive = false,
}) => {
  const [isSelecting, setIsSelecting] = useState<boolean>(false);
  const [selectedBoosters, setSelectedBoosters] = useState<Set<string>>(
    new Set()
  );
  const { showAlert } = useAlert();
  const { t } = useTranslation();

  const toggleSelectBooster = (id: string) => {
    setSelectedBoosters((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  };

  const toogleSelecting = () => {
    setIsSelecting(!isSelecting);
    const emptySet: Set<string> = new Set();
    setSelectedBoosters(emptySet);
  };

  const handleDeleteBoosters = async () => {
    try {
      const numberArray = Array.from(selectedBoosters);

      const res = await deleteBoosters(numberArray);

      if (res.errors.storeBoosters?.length > 0) {
        showAlert(
          t("alert.boosters.delete.error.inStore", {
            count: res.errors.storeBoosters.length,
          })
        );
      }

      if (res.errors.collectorBoosters?.length > 0) {
        showAlert(
          t("alert.boosters.delete.error.bought", {
            count: res.errors.collectorBoosters.length,
          })
        );
      }

      showAlert(
        t("alert.boosters.delete.success", {
          count: res.deletedIds.length,
        })
      );

      if (!handleAddOrRemoveBoosters) return;
      var newBoosters = boosters.filter(
        (booster) => !res.deletedIds.includes(booster.id)
      );

      handleAddOrRemoveBoosters(newBoosters);
    } catch {
      showAlert(t("alert.boosters.delete.error.default"));
    }
  };

  const handleArchiveBoosters = async () => {
    try {
      const numberArray = Array.from(selectedBoosters);
      await archiveBoosters(numberArray);

      showAlert(
        t("alert.boosters.update.archive.success", {
          count: numberArray.length,
        })
      );

      if (!handleAddOrRemoveBoosters) return;
      var newBoosters = boosters.filter(
        (booster) => !numberArray.includes(booster.id)
      );

      handleAddOrRemoveBoosters(newBoosters);
    } catch {
      showAlert(t("alert.boosters.update.archive.error"));
    }
  };

  return (
    <>
      <div className={cardStyles.selectButtonContainer}>
        <button
          className={`${globalStyles.button} ${
            isSelecting && cardStyles.active
          }`}
          onClick={toogleSelecting}
        >
          {t("boosters.select")}
        </button>
      </div>
      {isSelecting && (
        <div className={cardStyles.actionButtonsContainer}>
          <div className={cardStyles.actionButtons}>
            <div>
              {selectedBoosters.size} {t("boosters.selected")}
            </div>
            <div className={cardStyles.actionButtons}>
              {!disableDelete && (
                <button
                  onClick={handleDeleteBoosters}
                  className={`${globalStyles.button}`}
                >
                  {t("delete")}
                </button>
              )}
              <button
                onClick={handleArchiveBoosters}
                className={`${globalStyles.button}`}
              >
                {showInArchive ? t("unarchive") : t("archive")}
              </button>
              <button
                className={`${globalStyles.button} ${cardStyles.cancelButton}`}
                onClick={toogleSelecting}
              >
                <FaTimes size={25} />
              </button>
            </div>
          </div>
        </div>
      )}
      <div className={styles.boosterContainer}>
        {boosters
          // .filter((booster) => (showInStore ? booster.is_in_store : true))
          .map((booster: boosterData, index) => (
            <div
              key={index}
              className={styles.boosterWidth}
              onClick={() => {
                isSelecting && toggleSelectBooster(booster.id);
              }}
            >
              {isSelecting && (
                <input
                  type="checkbox"
                  checked={selectedBoosters.has(booster.id)}
                  className={cardStyles.selectCards}
                  readOnly={true}
                />
              )}
              <Booster
                booster={booster}
                isInStore={showInStore ?? true}
                disableClick={isSelecting}
                disableHover={isSelecting}
              />
            </div>
          ))}
      </div>
    </>
  );
};

export default ShowBoosters;
